import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type LicenseTemplate = z.infer<typeof schemas.LicenseTemplate>
export type LicenseSummary = z.infer<typeof schemas.LicenseSummary>
export type LicenseParty = z.infer<typeof schemas.LicenseParty>
export type LicenseTemplateSummary = z.infer<typeof schemas.LicenseTemplateSummary>
export type License = z.infer<typeof schemas.License>
export type LicenseIdField = z.infer<typeof schemas.LicenseIdField>
export type LicenseField = z.infer<typeof schemas.LicenseField>
export type LicenseTemplateField = z.infer<typeof schemas.LicenseTemplateField>
export type LicenseDocument = z.infer<typeof schemas.LicenseDocument>
export type LicenseHistory = z.infer<typeof schemas.LicenseHistory>
export const LicenseTemplateStatus = schemas.LiveEnum
export type LicenseTemplateStatus = z.infer<typeof LicenseTemplateStatus>
export const LicenseStatus = schemas.ActiveEnum
export type LicenseStatus = z.infer<typeof LicenseStatus>
export type LicenseBlock = z.infer<typeof schemas.LicenseBlock>
export const LicenseApplicationType = schemas.NewEnum
export type LicenseApplicationType = z.infer<typeof LicenseApplicationType>

export interface LicenseFilterRequest {
  status_list?: LicenseStatus[]
  issued_on_from?: string
  issued_on_to?: string
  expires_on_from?: string
  expires_on_to?: string
}
